var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicePointColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20062_282846)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.704 4.69829L9.54734 1.37763C8.63201 0.649626 7.35201 0.64896 6.43267 1.37896L2.306 4.69029C1.80133 5.07296 1.50733 5.65363 1.5 6.28896V13.3356C1.5 13.6116 1.724 13.8356 2 13.8356C2.276 13.8356 2.5 13.6116 2.5 13.3356V6.29429C2.50333 5.97629 2.65333 5.68229 2.92133 5.47896L7.05667 2.16029C7.60667 1.72429 8.37534 1.72296 8.92401 2.15963L13.094 5.48963C13.3433 5.67563 13.4953 5.97696 13.4993 6.28896V13.3356C13.4993 13.6116 13.7233 13.8356 13.9993 13.8356C14.2753 13.8356 14.4993 13.6116 14.4993 13.3356V6.28163C14.49 5.65296 14.188 5.05763 13.704 4.69829Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1837 10.106L9.56903 10.1105C9.24974 10.1105 8.96694 10.22 8.76168 10.4298C8.5473 10.6442 8.42871 10.9544 8.42871 11.3056L8.43327 12.6968C8.43783 13.3946 8.90764 13.8781 9.57815 13.8781L11.1928 13.8736C11.5167 13.8736 11.7949 13.7641 12.0002 13.5588C12.2146 13.3444 12.3331 13.0343 12.3331 12.6831L12.3286 11.2919C12.3286 10.594 11.8588 10.106 11.1837 10.106Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77081 8.99739C8.97606 9.19808 9.24974 9.30299 9.56903 9.30299H11.1928C11.877 9.29843 12.3331 8.81949 12.3331 8.10793L12.3286 6.83534C12.3286 6.13747 11.8588 5.64941 11.1837 5.64941L9.56903 5.65398C9.24974 5.65398 8.9715 5.76345 8.76168 5.97326C8.5473 6.18764 8.42871 6.49781 8.42871 6.84902L8.43327 8.12161C8.43783 8.47283 8.55643 8.783 8.77081 8.99739Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0169 11.9444H10.7467C10.9383 11.9444 11.0888 11.794 11.0888 11.6023C11.0888 11.4153 10.9383 11.2603 10.7467 11.2603H10.0169C9.82989 11.2603 9.6748 11.4153 9.6748 11.6023C9.6748 11.794 9.82989 11.9444 10.0169 11.9444Z",
    fill: "#3694FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7467 6.80322H10.0169C9.82989 6.80322 9.6748 6.95831 9.6748 7.14532C9.6748 7.33689 9.82989 7.48741 10.0169 7.48741H10.7467C10.9383 7.48741 11.0888 7.33689 11.0888 7.14532C11.0888 6.95831 10.9383 6.80322 10.7467 6.80322Z",
    fill: "#3694FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42199 7.00928H4.80731C4.46977 7.01384 4.18241 7.13699 3.98172 7.34681C3.78102 7.56119 3.66699 7.85311 3.66699 8.20433L3.67155 12.5877C3.67155 12.9389 3.79015 13.2491 4.00453 13.4634C4.20978 13.6641 4.48802 13.769 4.80275 13.769H6.43111C7.10161 13.7645 7.57142 13.2719 7.56686 12.574V8.1952C7.56686 7.84399 7.44371 7.53382 7.22933 7.31944C7.02407 7.11419 6.73671 7.01384 6.42199 7.00928Z",
    fill: "#C6E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24932 8.9884H5.98368C6.17069 8.9884 6.32578 8.83787 6.32578 8.64629C6.32578 8.45928 6.17069 8.3042 5.98368 8.3042H5.24932C5.06231 8.3042 4.90723 8.45928 4.90723 8.64629C4.90723 8.83787 5.06231 8.9884 5.24932 8.9884Z",
    fill: "#3694FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20062_282846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePointColor);
export default __webpack_public_path__ + "static/media/service_point_color.b8ac826869f661c6976cb393456b4ff0.svg";
export { ForwardRef as ReactComponent };